import { session } from '@farmersdog/utils';

export const CALCULATING_SCREEN_SUPPRESED_TOKEN_KEY =
  'tosa-calculating-screen-suppresed';

function isSuppressed(): boolean {
  const suppressedStatus = session.getItem(
    CALCULATING_SCREEN_SUPPRESED_TOKEN_KEY
  );

  return suppressedStatus === 'true';
}

function setAsSuppressed(): void {
  session.setItem(CALCULATING_SCREEN_SUPPRESED_TOKEN_KEY, 'true');
}

export const tosaCalculatingScreenSuppressed = {
  isSuppressed,
  setAsSuppressed,
};
